<template>
    <div class="dropdown" @mouseover="isOpen = true" @mouseleave="isOpen = false">  
        <a href="/#" class="button-dropdown el" v-if="!isOpen">
                {{ title }}
        </a>
        <a href="/#" class="button-dropdown el" v-if="isOpen">
                {{ title }}
        </a>

        <transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <div class="menu-item2 cel">
                        <a href="/embriomitriki-iatriki/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΜΗΜΑ ΕΜΒΡΥΟΜΗΤΡΙΚΗΣ ΙΑΤΡΙΚΗΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <p>Η Μονάδα της Εμβρυομητρικής Ιατρικής και Υπερήχων στη Μαιευτική – Γυναικολογία από τις 11 Απριλίου 2008 αναγνωρίστηκε από την European Board and College of Obstetrics and Gynecology (EBCOG)</p>
                    </div>
                    <a href="/embriomitriki-iatriki/" class="arrow-button big-button green">Περισσότερα
    
    <div class="arrow-outer">
        <div class="arrow">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
        </div>
        <div class="arrow-filled-container">
        <div class="arrow-filled" style="width: 120.281px;">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
            </div>
        </div>
    </div>
                        
    </a>              

                </div>
                <div class="menu-col1 el">
                    <div class="menu-item2 let">
                        <a href="/arxomeni-kiisi/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΜΗΜΑ ΑΡΧΟΜΕΝΗΣ ΚΥΗΣΗΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <p>Αποτελεί καινούριο τμήμα στην Α Μαιευτική Πανεπιστημιακή Κλινική και αφορά σε περιστατικά 1ου τριμήνου της κύησης. Πιο συγκεκριμένα, χειρίζεται διαγνωστικά (Γυναικολογική Υπερηχογραφία)</p>
                    </div>
                   <a href="/arxomeni-kiisi/" class="arrow-button big-button green">Περισσότερα
    <div class="arrow-outer">
        <div class="arrow">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
        </div>
        <div class="arrow-filled-container">
        <div class="arrow-filled" style="width: 120.281px;">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
            </div>
        </div>
    </div>
                        
    </a>
                </div>
                <div class="menu-col1 menu-last">
                    <div class="menu-item2 per">
                        <a href="/pathiseis-mastou"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΜΗΜΑ ΠΑΘΗΣΕΩΝ ΜΑΣΤΟΥ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <p>Η Μονάδα Μαστού της Α΄ Μαιευτικής & Γυναικολογικής Κλινικής του Πανεπιστημίου Αθηνών λειτουργεί από το έτος 1979 και εδράζεται στον 4ο όροφο του Νοσοκομείου «Αλεξάνδρα», οδός Β. Σοφίας 80</p>
                    </div> 
                    <a href="/pathiseis-mastou" class="arrow-button big-button green">Περισσότερα
    
    <div class="arrow-outer">
        <div class="arrow">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
        </div>
        <div class="arrow-filled-container">
        <div class="arrow-filled" style="width: 120.281px;">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
            </div>
        </div>
    </div>
                        
    </a>
                     

                </div>
                <div class="menu-col1 menu-last">
                    <div class="menu-item2 per">
                        <a href="/ginekologiki-ogkologia"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΤΜΗΜΑ ΓΥΝΑΙΚΟΛΟΓΙΚΗΣ ΟΓΚΟΛΟΓΙΑΣ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <p>Το Ογκολογικό Τμήμα της Κλινικής αντιμετωπίζει ασθενείς με κακοήθη νεοπλάσματα του γυναικείου γεννητικού συστήματος. Η αντιμετώπιση συνίσταται στην πρωτογενή θεραπεία νέων ασθενών</p>
                    </div> 
                    <a href="/ginekologiki-ogkologia" class="arrow-button big-button green">Περισσότερα
    
    <div class="arrow-outer">
        <div class="arrow">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
        </div>
        <div class="arrow-filled-container">
        <div class="arrow-filled" style="width: 120.281px;">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 8" style="enable-background:new 0 0 7 8;" xml:space="preserve">
            <style type="text/css"></style>
            <path class="st0" d="M6.4,3.6L3.2,0.5C3,0.3,2.7,0.3,2.5,0.5S2.3,1,2.5,1.2l2.3,2.3H0v1h4.8L2.5,6.8C2.3,7,2.3,7.3,2.5,7.5
                s0.5,0.2,0.7,0l3.2-3.2C6.5,4.2,6.5,3.8,6.4,3.6z"></path>
            </svg>
            </div>
        </div>
    </div>
                        
    </a> 

                </div>
            </div>
            </div>
        </transition>
    </div>
</template>


<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items','itemsen','titlen'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>
.img-text{
    display: flex;
    gap:15px !important;
    padding-left: 40px;
    margin-bottom: 25px;
}
.menu-col{
    width: 65% !important;
    padding-top: 50px !important;
    padding-left: 240px !important;
}

.menu-col1{
    width: 35% !important;
    padding-right: 240px !important;
    border-left: 1px solid #e5e5e5;
    padding-top: 50px;
    padding-bottom: 25px;
}
.menu-item1{
    display: flex;
}

    .dropdown{
        text-align: center;
    }
    .button-dropdown {
        font-size: 40px;
        text-decoration: none;
        color:#222 !important;
        display: inline-block;
        position: relative;
    }
 
 .button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #222;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.button-dropdown:hover:after{
  transform: scaleX(1);
  transform-origin: bottom left;
}
    .button-dropdown svg{
        margin-left: 10px;
        width:15px !important;
        filter:none !important;
    }
    .menu-item svg{
        width:10px !important;
        
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .sidebar-drop img{
        width: 120px !important;
        height: 90px !important;
        object-fit: cover;
        border-radius: 5px !important;
    }
    .sidebar-drop{
        border-top: 1px solid #e7e7e7;
        background-color: #fffdfd;
        width:100% !important;
        z-index: 99;
        box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding: 0px 0;
        margin-top: 20px;
        overflow: scroll;
        display: flex;
        overflow-x: hidden;
    }
 

   
    .sidebar-drop .menu-item1 {
        font-size: 20px;
        padding: 9px 40px;
        font-weight: 600;
    }

    .sidebar-drop .menu-item1 a{
       text-align: left;
       text-decoration: none;
       color:#222;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
    }
    .title-text a{
        text-decoration: none;
        color:#222 !important
    }
    .title-text a:hover{
        color:#719452 !important
    }
    /* .sidebar-drop .menu-item1 a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #222;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }*/

    .sidebar-drop .menu-item1 a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }
    .sidebar-drop.menu-item1:hover{
        background-color: #fff;
        color:#222;     
    }
    .sidebar-drop .menu-item1 a:hover{
        color:#719452 !important
    }
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.4s ease-out;
    }

.slide-up-enter,.slide-up-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
/*
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}*/

@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar{
        width:100% !important;
    }
}

</style>